import logo from '../logos/sparx_maths_logo.svg';

export const SparxMathsLogo = () => {
  return <img src={logo} style={{ width: 150 }} alt="Sparx Maths" />;
};
